import React, { useState } from 'react';
import { FinancePlansTab } from './FinancePlansTab';
import { BillingTab } from './BillingTab';
import { ReportsTab } from './ReportsTab';
import { Settings } from 'lucide-react';

type TabType = 'plans' | 'billing' | 'reports';

export function FinancePage() {
  const [activeTab, setActiveTab] = useState<TabType>('plans');

  const tabs: { id: TabType; label: string }[] = [
    { id: 'plans', label: 'Finance Plans' },
    { id: 'billing', label: 'Billing' },
    { id: 'reports', label: 'Reports' },
  ];

  return (
    <div className="min-h-full">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Finance</h1>
          <p className="text-sm text-gray-500">Administrator Platform</p>
        </div>
        <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center gap-2">
          <Settings className="w-4 h-4" />
          Manage Courses
        </button>
      </div>

      {/* Tabs */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="flex gap-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`pb-4 text-sm font-medium transition-colors relative ${
                activeTab === tab.id
                  ? 'text-teal-600 border-b-2 border-teal-600'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'plans' && <FinancePlansTab />}
        {activeTab === 'billing' && <BillingTab />}
        {activeTab === 'reports' && <ReportsTab />}
      </div>
    </div>
  );
}

export default FinancePage;
